import * as i0 from '@angular/core';
import { Component, NgModule } from '@angular/core';
import * as i1 from '@capturum/builders/list-renderer';
import { CapturumListRendererModule } from '@capturum/builders/list-renderer';
import { CapturumPowerBIModule } from '@capturum/powerbi';
import { CapturumBuilderCoreModule } from '@capturum/builders/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CapturumInputModule } from '@capturum/ui/input';
import { CapturumButtonModule } from '@capturum/ui/button';
import { TranslateModule } from '@ngx-translate/core';
import { CapturumBuilderUiModule } from '@capturum/builders/ui';
import { CapturumFormRendererModule } from '@capturum/builders/form-renderer';
import { CapturumInfoTableModule } from '@capturum/ui/info-table';
import { CapturumSharedModule } from '@capturum/ui/api';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
let CapturumPowerBIClientsManageComponent = /*#__PURE__*/(() => {
  class CapturumPowerBIClientsManageComponent {
    static {
      this.ɵfac = function CapturumPowerBIClientsManageComponent_Factory(t) {
        return new (t || CapturumPowerBIClientsManageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBIClientsManageComponent,
        selectors: [["cap-pbi-clients-manage"]],
        decls: 1,
        vars: 0,
        consts: [["key", "list_manage_power_bi_clients"]],
        template: function CapturumPowerBIClientsManageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cpb-list-renderer", 0);
          }
        },
        dependencies: [i1.CapturumListRendererComponent],
        encapsulation: 2
      });
    }
  }
  return CapturumPowerBIClientsManageComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPowerBIReportsManageComponent = /*#__PURE__*/(() => {
  class CapturumPowerBIReportsManageComponent {
    static {
      this.ɵfac = function CapturumPowerBIReportsManageComponent_Factory(t) {
        return new (t || CapturumPowerBIReportsManageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBIReportsManageComponent,
        selectors: [["cap-pbi-reports-manage"]],
        decls: 1,
        vars: 0,
        consts: [["key", "list_manage_power_bi_reports"]],
        template: function CapturumPowerBIReportsManageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cpb-list-renderer", 0);
          }
        },
        dependencies: [i1.CapturumListRendererComponent],
        encapsulation: 2
      });
    }
  }
  return CapturumPowerBIReportsManageComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const routes = [{
  path: 'reports',
  component: CapturumPowerBIReportsManageComponent
}, {
  path: 'clients',
  component: CapturumPowerBIClientsManageComponent
}];
const routerModule = RouterModule.forChild(routes);
let CapturumPowerBIPagesRoutingModule = /*#__PURE__*/(() => {
  class CapturumPowerBIPagesRoutingModule {
    static {
      this.ɵfac = function CapturumPowerBIPagesRoutingModule_Factory(t) {
        return new (t || CapturumPowerBIPagesRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumPowerBIPagesRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [routerModule, RouterModule]
      });
    }
  }
  return CapturumPowerBIPagesRoutingModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPowerBIPagesModule = /*#__PURE__*/(() => {
  class CapturumPowerBIPagesModule {
    static {
      this.ɵfac = function CapturumPowerBIPagesModule_Factory(t) {
        return new (t || CapturumPowerBIPagesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumPowerBIPagesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CapturumPowerBIPagesRoutingModule, CapturumFormRendererModule, CapturumListRendererModule, CapturumBuilderCoreModule, CapturumPowerBIModule, ReactiveFormsModule, CapturumInputModule, CapturumButtonModule, CapturumInfoTableModule, TranslateModule, CapturumBuilderUiModule, CapturumSharedModule]
      });
    }
  }
  return CapturumPowerBIPagesModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of power-bi/pages
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumPowerBIClientsManageComponent, CapturumPowerBIPagesModule, CapturumPowerBIReportsManageComponent };
